<template>
  <ModalBase v-bind="$attrs" v-on="$listeners" @change:modal="onChangeModal">
    <div slot="content">
      <h1>{{ lang.title }}</h1>
      <v-select v-model="locale" :items="locales" v-if="locales" item-text="text" item-value="code"></v-select>
      <div class="text-xs-center">
        <Button :text="lang.button" color="primary" :handleClick="onButtonClick"></Button>
      </div>
    </div>
  </ModalBase>
</template>

<script>
import { mapActions, mapState } from "vuex";

import ModalBase from "./ModalBase";
import Button from "./Button";

export default {
  inheritAttrs: false,
  components: {
    ModalBase,
    Button
  },
  data() {
    return {
      locale: null
    };
  },
  computed: {
    ...mapState({
      locales: state => state.locales.locales,
      employee: state => state.employee.employee
    }),
    lang() {
      return {
        title: this.$t(window.Vocabulary.changeLang),
        button: this.$t(window.Vocabulary.resetLang)
      };
    }
  },
  methods: {
    ...mapActions(["fetchLocales", "postLocale"]),
    onButtonClick() {
      this.postLocale(this.locale);
    },
    onChangeModal(val) {
      if (!val) {
        this.locale = window.localStorage.getItem("locale");
      }
    }
  },
  watch: {
    employee: {
      handler(data) {
        this.locale = data.userAttributes.locale;
      }
    }
  },
  mounted() {
    this.fetchLocales();
  }
};
</script>

<style lang="scss" scoped>
</style>